export default "/_next/static/images/post-filled-icon-legacy-3c9daa4d77bfb6227b22ef6632f2eb56.svg";